export default "__VITE_ASSET__a4f94a77__"